import React, { useEffect, useRef, useState } from "react";
import { graphql } from "gatsby";
import gsap from "gsap";

const CampaignVideo = ({ desktopVideo, mobileVideo }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const [hasScrolled, setHasScrolled] = useState(false);

  const triggerAnimation = () => {
    if (!sectionRef.current) return;

    // Trigger GSAP animation to scroll upwards
    gsap.to(sectionRef.current, {
      y: "-100vh",
      duration: 1.5,
      ease: "power4.inOut",
      onComplete: () => {
        // Remove the block from the DOM
        setIsVisible(false);
      },
    });
  };

  useEffect(() => {
    if (!sectionRef.current) return;

    const handleScroll = () => {
      if (window.scrollY > 100 && !hasScrolled) {
        setHasScrolled(true);
        triggerAnimation();
      }
    };

    // Play the video for 17 seconds
    const timer = setTimeout(() => {
      triggerAnimation();
    }, 17000); // 17 seconds

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasScrolled]);

  if (!isVisible) return null;

  return (
    <section ref={sectionRef} className="campaign-video">
      {desktopVideo && (
        <video
          className="campaign-video__video campaign-video__video--desktop"
          src={desktopVideo}
          autoPlay
          muted
          playsInline
        />
      )}
      {mobileVideo && (
        <video
          className="campaign-video__video campaign-video__video--mobile"
          src={mobileVideo}
          autoPlay
          muted
          playsInline
        />
      )}
    </section>
  );
};

export default CampaignVideo;

export const query = graphql`
  fragment CampaignVideoProps on DatoCmsCampaignVideo {
    ... on DatoCmsCampaignVideo {
      id
      desktopVideo
      mobileVideo
    }
  }
`;
